import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface InsulationProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Insulation: React.FC<InsulationProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [insulation, set_insulation] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Insulation'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Insulation': v } } })
    );
    const label = 'Insulation';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(insulation)}
                />
            ) : (
                <MoneyBox
                    id={'insulation'}
                    allowNegative={false}
                    value={insulation}
                    onChange={(value) => set_insulation(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
